module.exports = __webpack_public_path__ + "img/Logo_Altenheim_lang_5cm.7639336b.png";